interface ChevronRightIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
}

const ChevronRightIcon = ({
  width = "24",
  height = "24",
  color = "currentColor",
}: ChevronRightIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M9 18L15 12L9 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronRightIcon;
